import React, { useState } from 'react';
import { AddItem, UpdateItem } from "../../../utils/functions";
import { useTranslation } from 'react-i18next';
import TextField from '../../../components/input/fields/text-field';
import { toast } from "react-toastify";
import { getAuth } from 'firebase/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'react-feather';
import { NavLink } from 'react-router-dom';

const Profile = () => {
    const { t } = useTranslation();
    const auth = getAuth();
    const navigator = useNavigate();

    const [formData, setFormData] = useState({
        displayName: auth.currentUser.displayName,
        email: auth.currentUser.email,
        password: null,
        newPassword: null,
        confirmPassword: null,
    });

    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
    const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
    const [isBtnDisable, setIsBtnDisable] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        let updatedFormData = null;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_-])[A-Za-z\d!@#$%^&*()_-]{8,}$/;

        e.preventDefault();
        setIsBtnDisable(true);

        if(!emailRegex.test(formData.email)) {
            toast.error(t("ToastErrorIncorrectEmail"));
            setIsBtnDisable(false);
            return;
        }

        if(formData.newPassword || formData.confirmPassword){
            if (!formData.newPassword){
                toast.error(t("ToastErrorPasswordRequired"));
                setIsBtnDisable(false);
                return;
            } 
                
            if(!formData.confirmPassword) {
                toast.error(t("ToastErrorConfirmPasswordRequired"));
                setIsBtnDisable(false);
                return;
            }

            if(!passwordRegex.test(formData.newPassword)){
                toast.error(t("ToastErrorIncorrectPassword"));
                setIsBtnDisable(false);
                return;
            }
            else{
                if (formData.newPassword !== formData.confirmPassword) {
                    toast.error(t("ToastErrorPasswordsMismatch"));
                    setIsBtnDisable(false);
                    return;
                }
    
                updatedFormData = {
                    uid: auth.currentUser.uid,
                    displayName: formData.displayName,
                    email: formData.email,
                    password: formData.newPassword,
                    confirmPassword: formData.confirmPassword
                }
            }
        }
        else if(!formData.newPassword && !formData.confirmPassword){
            updatedFormData = {
                uid: auth.currentUser.uid,
                displayName: formData.displayName,
                email: formData.email,
                password: null,
                confirmPassword: null
            }
        }
        
        if(updatedFormData){
            await UpdateItem('User', updatedFormData);
        }

        setIsBtnDisable(false);
    };

    return (
        <div className="p-lg-4 ps-4 pt-5 mx-auto w-80vw">
            <div className="mt-5 container-admin">
                <div className="row">
                    <NavLink className="come-back-admin" to={"/admin"}>
                        <FontAwesomeIcon icon={faAngleLeft} />
                        {t("Back")}
                    </NavLink>
                    <div className="row mt-2">
                        <div className="mt-3">
                            <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                                {t("GeneralInfo")}
                            </h5>
                        </div>
                        <div className="flex-wrap col-lg-5 my-3">
                            <div className="d-flex flex-column">
                                <TextField
                                    id={"displayName"}
                                    name={"displayName"}
                                    label={t("FullName")}
                                    type={"text"}
                                    inputClassName={"grey-input mt-1 w-100 ps-3"}
                                    placeholder={t("Insert")}
                                    onChange={handleChange}
                                    value={formData.displayName}
                                    required
                                />
                            </div>
                        </div>
                        <div className="flex-wrap col-lg-5 my-3 d-flex">
                            <div className="d-flex flex-column w-100">
                                <TextField
                                    id={"email"}
                                    name={"email"}
                                    label={t("Email")}
                                    type={"text"}
                                    inputClassName={"grey-input mt-1 w-100 ps-3"}
                                    placeholder={t("Insert")}
                                    onChange={handleChange}
                                    value={formData.email}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-lg-2 ps-4 d-flex align-items-end justify-content-end pb-3">
                            <button onClick={handleSubmit} className="admin-button border-none text-uppercase" >{t("Update")}</button>
                        </div>
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="mt-3">
                        <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                            {t("ChangePassword")}
                        </h5>
                    </div>
                    <div className="row">
                        <div className="flex-wrap col-lg-6 col-12 my-3 d-flex">
                            <div className="d-flex position-relative w-lg-50 w-100">
                                <TextField
                                    id={"password"}
                                    name={"password"}
                                    label={t("Password")}
                                    type={isNewPasswordVisible ? "text" : "password"}
                                    inputClassName={"grey-input mt-1 w-100 ps-3"}
                                    placeholder={t("Insert")}
                                    className={"w-100"}
                                    onChange={handleChange}
                                    value={formData.password}
                                    required
                                />
                                <button
                                    className="position-absolute end-0 bg-transparent border-none mt-2 pt-3 pe-2 top-50 translate-middle-y"
                                    onClick={() => setIsNewPasswordVisible(!isNewPasswordVisible)}
                                >
                                    {isNewPasswordVisible ? <Eye className="text-base text-black" size={18} /> : <EyeOff className="text-base text-black" size={18} />}
                                </button>
                            </div>
                        </div>
                        </div>
                        <div className="row">
                            <div className="flex-wrap col-lg-5 col-12 my-3">
                                <div className="d-flex flex-column position-relative">
                                    <TextField
                                        id={"newPassword"}
                                        name={"newPassword"}
                                        label={t("NewPassword")}
                                        type={isConfirmPasswordVisible ? "text" : "password"}
                                        inputClassName={"grey-input mt-1 w-100 ps-3"}
                                        placeholder={t("Insert")}
                                        onChange={handleChange}
                                        value={formData.newPassword}
                                        required
                                    />
                                    <button
                                        className="position-absolute end-0 bg-transparent border-none mt-2 pt-3 pe-2 top-50 translate-middle-y"
                                        onClick={() => setIsConfirmPasswordVisible(!isConfirmPasswordVisible)}
                                    >
                                        {isConfirmPasswordVisible ? <Eye className="text-base text-black" size={18} /> : <EyeOff className="text-base text-black" size={18} />}
                                    </button>
                                    <p className="paragraph position-absolute start-0 top-100 font-description-small ">Minimum of 8 characters, with upper and lowercase and a number, or a symbol.</p>
                                </div>
                            </div>
                            <div className="flex-wrap col-lg-5 col-12 my-3">
                                <div className="d-flex flex-column position-relative">
                                    <TextField
                                        id={"confirmPassword"}
                                        name={"confirmPassword"}
                                        label={t("ConfirmPassword")}
                                        type={isPasswordVisible ? "text" : "password"}
                                        inputClassName={"grey-input mt-1 w-100 ps-3"}
                                        placeholder={t("Insert")}
                                        onChange={handleChange}
                                        value={formData.confirmPassword}
                                        required
                                    />
                                    <button
                                        className="position-absolute end-0 bg-transparent border-none mt-2 pt-3 pe-2 top-50 translate-middle-y"
                                        onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                                    >
                                        {isPasswordVisible ? <Eye className="text-base text-black" size={18} /> : <EyeOff className="text-base text-black" size={18} />}
                                    </button>
                                </div>
                            </div>
                        <div className="col-lg-2 ps-4 d-flex align-items-end justify-content-end pb-3">
                            <button onClick={handleSubmit} className="admin-button border-none text-uppercase" disabled={isBtnDisable}>{t("Update")}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;
